import React, { useContext, useEffect } from 'react';
import { DocumentOutlineContext } from './DocumentOutlineProvider';
import Heading from './Heading';

/** @public */
function OutlineHeading(_ref) {
  var _useContext;

  var h = _ref.h,
      id = _ref.id,
      title = _ref.title,
      children = _ref.children,
      className = _ref.className;

  var _ref2 = (_useContext = useContext(DocumentOutlineContext)) !== null && _useContext !== void 0 ? _useContext : {},
      registerNode = _ref2.registerNode;

  useEffect(function () {
    if (!registerNode) return undefined;
    return registerNode(+h, title, id); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerNode]);
  return /*#__PURE__*/React.createElement(Heading, {
    id: id,
    level: h,
    className: className
  }, children);
}

export default OutlineHeading;